import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
//Components
import Layout from '../common/Layout';
// Redux
import { useSelector, useDispatch } from 'react-redux';
import { Box, Button } from '@material-ui/core';
import { useSyles } from './Repayments.styles';
import { getUserLoan, loanRepayment } from '../../redux/loans/thunks';
import WrapperLoan from '../common/WrapperLoan';
import {
  CheckCircleRounded,
  Close,
  GroupAddRounded,
  VpnKey,
  VpnKeyRounded,
} from '@material-ui/icons';
import SearchInvisible from '../common/SearchInvisible/SearchInvisible';
import ButtonBarcode from '../common/ButtonBarcode';
import { setCurrent } from '../../redux/renovation/thunk';
import useScan from '../../hooks/useScan';
import Swal from 'sweetalert2';
import { RenovationKeyField } from '../../domain/constants/RenovationField';
import { mediumDate } from '../../helpers/datetime';

const Repayments = (props: any) => {
  const dispatch = useDispatch<any>();
  const classes: any = useSyles();
  const navigate = useNavigate();
  const [showResume, setShowResume] = useState(false);
  const [keysLoan, setKeysLoan] = useState<any>([]);
  const initialError = { user: '', keys: '' };
  const [error, setError] = useState(initialError);
  const [sending, setSending] = useState(false);
  const initialSteps = {
    user: false,
    keys: false,
    complete: false,
  };
  const initialValuesLoan = {
    users_id: '',
    keys: [1],
  };
  const [steps, setSteps] = useState(initialSteps);
  const [valuesLoan, setValuesLoan] = useState(initialValuesLoan);

  // obtener el state
  const { name, email, keys } = useSelector(
    (state: any) => state.loans.userLoan
  );
  const renovation = useSelector((state: any) => state.renovation);
  const { setDestination } = useScan();

  useEffect(() => {
    setDestination('act-a-rep', false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const keysAvailable = keys?.map((item: any) => {
      return { ...item, active: false };
    });
    setKeysLoan(keysAvailable);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keys]);

  /* buscar usuario */
  const submitFilterUser = (value: any) => {
    if (value) {
      const isEmail = value.includes('@');
      const filter = isEmail ? `&email=${value}` : `&user_id=${value}`;
      dispatch(getUserLoan(filter))
        .unwrap()
        .then((res: any) => {
          if (res.name) {
            setValuesLoan({ ...valuesLoan, users_id: res.id });
            setSteps({ ...steps, user: true });
            setError({ ...error, user: '' });
          } else {
            setValuesLoan({ ...valuesLoan, users_id: '' });
            setSteps({ ...steps, user: false });
            setError({ ...error, user: res.message });
          }
        });
    } else {
      setValuesLoan({ ...valuesLoan, users_id: '' });
      setSteps({ ...steps, user: false });
    }
  };

  /* agregar llaves*/
  const submitkeys = (value: any) => {
    const index = keysLoan?.findIndex((item: any) => item.barcode === value);
    if (index !== -1) {
      const _keysLoan = [...keysLoan];
      _keysLoan[index].active = !_keysLoan[index].active;
      const activeKeys = _keysLoan.filter((k) => k.active).length;
      setSteps({ ...steps, keys: activeKeys > 0 });
      setKeysLoan(_keysLoan);
    } else {
      Swal.fire({
        icon: 'error',
        title: 'La llave escaneada, no corresponde con ninguna en prestamo',
        text: 'Por favor, intenta de nuevo',
      });
    }
  };

  // cancelar
  const handleCancel = () => {
    setSteps(initialSteps);
    setValuesLoan(initialValuesLoan);
    setKeysLoan([]);
    setShowResume(false);
    setError(initialError);
  };

  // continuar
  const handleContinue = () => {
    const activeKeys = keysLoan.filter((k: any) => k.active);
    const selectedKeys = activeKeys.map((key: any) => key.keys_id);
    setValuesLoan({ ...valuesLoan, keys: selectedKeys });
    setKeysLoan(activeKeys);
    setShowResume(true);
    if (steps.user && steps.keys) {
      setSteps({ ...steps, complete: true });
    }
  };

  const handleSendLoan = () => {
    const { users_id, keys } = valuesLoan;
    if (users_id && keys.length > 0) {
      setSending(true);
      if (sending) {
        return;
      }
      dispatch(loanRepayment(valuesLoan))
        .unwrap()
        .then(() => {
          setTimeout(function () {
            navigate(0);
          }, 3000);
        });
    }
  };
  //Código de barras
  useEffect(() => {
    const executeProcess = async () => {
      if (renovation?.actionInProcess) {
        switch (renovation.process.prefix.toLowerCase()) {
          case 'usr':
            submitFilterUser(renovation.process.id);
            break;
          case RenovationKeyField.prefix:
            submitkeys(renovation.process.barcode);
            break;
          case 'con':
            handleContinue();
            break;
          case 'can':
            handleCancel();
            break;
          case 'fin':
            handleSendLoan();
            break;
        }
        dispatch(
          setCurrent({
            currentView: renovation.currentView,
            url: renovation.url,
            actionInProcess: false,
            process: {},
            title: renovation.title,
          })
        );
      }
    };
    executeProcess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renovation?.actionInProcess]);

  //Fin de los filtros
  return (
    <Layout>
      <WrapperLoan>
        <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
          <Box
            className={`${classes.boxicon} ${
              steps.user ? classes.iconActive : ''
            }`}
          >
            <GroupAddRounded className={classes.icon} />
            <p>Usuario</p>
          </Box>
          <Box
            className={`${classes.boxicon} ${
              steps.keys ? classes.iconActive : ''
            }`}
          >
            <VpnKeyRounded className={classes.icon} />
            <p>Llaves</p>
          </Box>
          <Box
            className={`${classes.boxicon} ${
              steps.complete ? classes.iconActive : ''
            }`}
          >
            <CheckCircleRounded className={classes.icon} />
            <p>Finalizar</p>
          </Box>
          <Box></Box>

          <Box
            className={`${classes.boxicon} ${classes.iconClose}`}
            onClick={handleCancel}
          >
            <Close className={classes.icon} />
            <p>Cancelar</p>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-evenly',
            gridGap: '16px',
            minHeight: '80px',
          }}
          className={`${showResume ? classes.resume : ''}`}
        >
          <Box>
            <>
              {steps.user && (
                <Box className={classes.info}>
                  <p>
                    <b>Usuario: </b> {name}
                  </p>
                  <p>{email}</p>
                  {!showResume && (
                    <div
                      className={classes.close}
                      onClick={() => handleCancel()}
                    >
                      <Close />
                    </div>
                  )}
                </Box>
              )}
              {/*  */}
            </>
          </Box>
          {error.user && (
            <Box className={classes.info}>
              <div className={classes.close} onClick={() => handleCancel()}>
                <Close />
              </div>
              {error.user}
            </Box>
          )}
          {/* listado de llaves */}
          {steps.user && (
            <>
              {keys?.length > 0 ? (
                <Box className={classes.boxButtons}>
                  {keysLoan?.map((key: any) => (
                    <Box key={key.keys_id}>
                      <Button
                        className={`${classes.buttonkey} ${
                          key.active ? classes.buttonKeyActive : ''
                        }`}
                        variant={key.active ? 'outlined' : 'text'}
                        startIcon={<VpnKey />}
                        onClick={
                          showResume ? undefined : () => submitkeys(key.barcode)
                        }
                      >
                        <span className='barcode'>{key.barcode}</span>
                        <span className='type'>{key.type_keys_str}</span>
                        <span className='description'>{key.description}</span>
                        <span className='end_date'>Devolución: </span>
                        <span
                          className={`end_date ${
                            key.loan.days_past_due < 0
                              ? classes.pastDevolution
                              : ''
                          }`}
                        >
                          {mediumDate(key.loan.end_date)}
                        </span>
                      </Button>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Box sx={{ fontSize: '20px', p: 3, bgcolor: '#FFDEDE' }}>
                  El usuario no tiene llaves en prestamo
                </Box>
              )}
            </>
          )}
        </Box>

        <Box sx={{ display: 'block', position: 'relative', height: '50px' }}>
          {/* seleccionar llaves */}
          {!showResume && (
            <SearchInvisible
              onHandleChange={submitkeys}
              placeholder='Escanea o selecciona el código de las llaves'
            />
          )}

          {/* buscador información usuario */}
          {!steps.user && (
            <SearchInvisible
              onHandleChange={submitFilterUser}
              placeholder='Escanea o digita el código del usuario'
            />
          )}
          {steps.complete && (
            <Box className={classes.verification}>
              Verifique los datos para finalizar
            </Box>
          )}
        </Box>

        {steps.keys && steps.user && !showResume && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-evenly',
              gridGap: '16px',
            }}
          >
            <ButtonBarcode
              id=''
              src='/barcodes/cancelar.png'
              onClick={handleCancel}
            />
            <ButtonBarcode
              id=''
              src='/barcodes/continuar.png'
              onClick={handleContinue}
            />
          </Box>
        )}
        {steps.keys && showResume && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-evenly',
              gridGap: '16px',
            }}
          >
            <ButtonBarcode
              id=''
              src='/barcodes/cancelar.png'
              onClick={handleCancel}
            />
            <ButtonBarcode
              id=''
              src='/barcodes/finalizar.png'
              onClick={handleSendLoan}
            />
          </Box>
        )}
      </WrapperLoan>
    </Layout>
  );
};

export default Repayments;
